<div class="pfs" *ngIf="flagged.length">
  <div class="pfs-title">Перевірка наявності товару</div>
  <div class="pfs-row" *ngFor="let f of shown">
    <p-tag [value]="severityLabel(f.severity)" [severity]="severityTag(f.severity)"></p-tag>
    <strong class="pfs-code">{{productLabel(f)}}</strong>
    <span>{{codeText(f)}}</span>
    <span class="pfs-numbers" *ngIf="via(f) as v">{{v}}</span>
    <span class="pfs-numbers" *ngIf="f.numbers as n">{{numbersText(n)}}</span>
  </div>
  <div class="pfs-more" *ngIf="hidden">І ще {{hidden}}. Повний перелік: кнопка «Перевірка наявності».</div>
</div>
